import { useSortableTable } from '~/hooks/useSortableTable';
import { Table } from '~/components/Table/Table';
import { Link } from '~/components/Link/Link';
import { Club } from '~/apis/ssf';

interface Props {
  isLoading: boolean;
  clubs: Club[];
}

export function ClubListTable({ clubs, isLoading }: Props) {
  const { register } = useSortableTable('name');

  return (
    <Table bg="even">
      <Table.Head>
        <Table.Row>
          <Table.Col {...register('name')} as="th">
            Förening
          </Table.Col>
          <Table.Col {...register('district__name')} as="th">
            Distrikt
          </Table.Col>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {isLoading ? (
          <Table.Loading cols={2} />
        ) : (
          clubs.map(result => (
            <Table.Row key={`club-${result.id}`}>
              <Table.Col>
                <Link to={`/clubs/${result.id}`}>{result.name}</Link>
              </Table.Col>
              <Table.Col>{result.district.name}</Table.Col>
            </Table.Row>
          ))
        )}
      </Table.Body>
    </Table>
  );
}
